import { useLocation } from "react-router";

export type IsAuthWrapperOutPut = boolean;

export default (): IsAuthWrapperOutPut => {
  const { pathname } = useLocation();
  return Boolean(
    [
      "/explorer/sign-in",
      "/explorer/sign-up",
      "/explorer/reset-password",
      "/explorer/confirm",
      "/public/",
    ].find((it) => pathname.includes(it)),
  );
};
